import React from 'react';

import { EnabledContextActionsQueryOperationQuery as EnabledContextActionsQueryOperation } from 'core/graphql';
import { useQuery } from 'shared/hooks';
import { Omit } from 'shared/utils';

import { ContextAction, ContextActionProps } from './ContextAction';
import { CONTEXT_ACTION_QUERY } from './gql';

type ContextActionContainerProps = Omit<
  'onMatchesChange' | 'contextActions',
  ContextActionProps
>;

export function ContextActionContainer({
  children,
  entityType,
  ...rest
}: ContextActionContainerProps) {
  const { data } =
    useQuery<EnabledContextActionsQueryOperation>(CONTEXT_ACTION_QUERY);

  const { contextActions, sumoLogicRegion } = data ?? {};

  return (
    <ContextAction
      contextActions={contextActions?.objects || []}
      entityType={entityType}
      sumoLogicRegion={sumoLogicRegion ?? undefined}
      {...rest}
    >
      {children}
    </ContextAction>
  );
}
